<section class="master_my_address" >
  <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
    <div class="column address_sectors" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
      fxFlexFill>
      <div class="add_address_head">
        <a (click)="addAddress()">
          <img src="../../../../../assets/images/icons/plus.svg" alt="">
          Add New Address
        </a>
      </div>
      <ng-container *ngIf="addressesList; else loadingTemplate">
        <ng-container *ngIf="addressesList.length; else noDataTemplate">
          <div class="address_box" *ngFor="let singleAddress of addressesList">
            <div class="address_head">
              <span
                class="type">{{singleAddress.type  === 'Other' ? singleAddress.type + ":" + singleAddress.other_type_name : singleAddress.type }}</span>
              <div>
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu" class="table-action-btn address_matmenu">
                  <button mat-menu-item (click)="editAddressDialog(singleAddress)">
                    <img src="../../../../../assets/images/icons//action_icons/edit.svg" alt="img">
                    <span>Edit</span>
                  </button>
                  <button mat-menu-item (click)="deleteDialog(singleAddress)">
                    <img src="../../../../../assets/images/icons//action_icons/delete.svg" alt="img">
                    <span>Delete</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="address_body">
              <p class="address_line" *ngIf="singleAddress.short_name">{{singleAddress.short_name}},</p>
              <p class="address_line" *ngIf="singleAddress.line_1">{{singleAddress.line_1}},</p>
              <p class="address_line" *ngIf="singleAddress.line_2 && singleAddress.landmark">{{singleAddress.line_2}},
                {{singleAddress.landmark}}</p>
              <p class="address_line" *ngIf="singleAddress.city && singleAddress.state && singleAddress.postal_code">
                {{singleAddress.city}}, {{singleAddress.state}}, {{singleAddress.postal_code}}</p>
              <p class="address_line" *ngIf="singleAddress.country">{{singleAddress.country}}</p>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #loadingTemplate>
        <div class="custom-loader custom_logo_loader">
          <img src='../../../../../assets/images2/loader.gif' alt="img" loading="lazy" />
        </div>
      </ng-template>
      <ng-template #noDataTemplate>
        <div class="no-data empty-img">
          <!-- EMPTY-STATE -->
          <img src='../../../../../../../assets/images/empty-imgs/no_address.svg' alt="img" loading="lazy" />
          <h4 class="no_state_heading">No Address</h4>
        </div>
      </ng-template>
      <!-- TABLE-PAGINATOR -->
      <div fxLayout="column" fxLayout.lg="column" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column"
        fxFlexFill fxLayoutGap="8px">
        <mat-paginator [length]="totalElements" [pageSize]="limit.value" (page)="changePage($event)"></mat-paginator>
      </div>
    </div>
  </div>
</section>
